/**
 * @function    linkifyCards
 * @param   {string}    [selectorClass = '.linkify-me']   CSS class to select
 * 
 * Finds all instances of the class, looks for the first link within it, and uses that URL to make the entire card clickable.
 * ONLY a single class is allowed. IDs forbidden b/c the required hash can't be safely whitelisted.
 * 
 * @todo    Attempt to delegate Ctrl/Apple keypress modifiers via the onclick. Cf. JS target.disapatchEvent(event) as possible fix, but it's funky and needs finessing.
 */
function linkifyCards(selectorClass) {
    'use strict';
    let selector = false;
    if (typeof selectorClass == 'undefined') { 
        selector = '.linkify-me';
    } else {
        selector = selectorClass.replace(/[^a-z0-9\.\_\- ]/gi,'');
    }
    if (!selector || selector == '') { return false; }
    const cards = document.querySelectorAll(selector);
    if (!cards) { return false; }

    cards.forEach(function(card){
        if (card.classList.contains('popup-video')) { return; }
        var link = card.querySelector('a');
        if (link) {
            /* analytics hook fix */
            if (link.classList.contains('linkify-link')) { 
                return; /* do not double init */
            } else {
                link.classList.add('linkify-link');
            }
            card.setAttribute('tabindex', '0');
            link.setAttribute('tabindex', '-1');
            card.addEventListener('click', function(){
                if (window.seismic_slick_carousel_swipping === true) return
                if (window.getSelection().toString() == false) { link.click(); }
            });
            card.addEventListener('keyup', function(e){
                if (typeof e.key != undefined && e.key.toLowerCase() == 'enter') {
                    link.click(); 
                } else if ( typeof e.keyCode != undefined && e.keyCode == 13 ) {
                    link.click(); 
                } 
            });
            link.addEventListener('click', function(event){
                event.stopPropagation();
            });
       }
    });

}

/*  DEPLOY IN FUTURE after proper testing */
// function linkifyCardsFacetWPHelper(lmSelectorClass) {
//     'use strict';
//     if (typeof FWP != 'object' || typeof lmSelectorClass == 'undefined') { return; }
//     var selector = lmSelectorClass.replace(/[^a-z0-9._-]/gi,'');
//     if (!selector || selector == '') { return false; }
//     /* find any instance of a card and any instance of a facet */
//     var card = document.querySelector(selector), facetElement = document.querySelector('.facetwp-facet');
//     if (card && facetElement) {
//         document.addEventListener('facetwp-loaded', function() {
//             linkifyCards('.linkify-me');
//         });
//     }
// }

document.addEventListener('DOMContentLoaded', function() {
    linkifyCards();
}, false);


